import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import { TabView, TabPanel } from "primereact/tabview";

import NouvellesNavettes from "./navette/nouvellesNavette";
import EnCours from "./navette/encoursNavette";
export default function Navettes() {
 
  return (
    <>
      <TabView>
        <TabPanel header="Partiels">
          <NouvellesNavettes />
        </TabPanel>

        <TabPanel header="En cours">
          <EnCours />
        </TabPanel>

        <TabPanel header="Terminé"></TabPanel>
      </TabView>
    </>
  );
}
